import OtherOrganMetastases from "./OtherOrganMetastases";

export default OtherOrganMetastases;
